import axios from 'axios';

const createResume = async ({ resumeData }) => {
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/resumes`, resumeData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return response.data;
};

const updateResume = async ({ resumeId, resumeData }) => {
  const response = await axios.put(`${process.env.REACT_APP_API_URL}/resumes/${resumeId}`, resumeData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return response.data;
};

const deleteResume = async ({ resumeId }) => {
  const response = await axios.delete(`${process.env.REACT_APP_API_URL}/resumes/${resumeId}`);

  return response.data;
};

const resumeService = {
  createResume,
  updateResume,
  deleteResume
};

export default resumeService;
